import { render, staticRenderFns } from "./goaltypecontent.vue?vue&type=template&id=3d928120"
import script from "./goaltypecontent.vue?vue&type=script&lang=js"
export * from "./goaltypecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports